/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const usePesquisa = (formikRef, valores = [], config = {}, onFilterChange) => {
  const { salvarLocalStorage = false, chave } = config;
  const pesquisaSelect = useSelect("pesquisa");

  const [pesquisa, setPesquisa] = useState(0);
  const [fila, setFila] = useState(null);
  const [dados, setDados] = useState(valores || []);

  useEffect(() => {
    setDados(valores || []);
  }, [valores]);

  const optionsPesquisa = useMemo(
    () => prepareForOptions(dados, ["title"], "id"),
    [dados]
  );

  const pesquisasObjId = useMemo(
    () => createObj({ key: "id", data: dados, prefix: "key-" }),
    [dados]
  );
  const pesquisasObjCodigo = useMemo(
    () => createObj({ key: "codigo", data: dados }),
    [dados]
  );
  const pesquisasObjNome = useMemo(
    () => createObj({ key: "nome", data: dados }),
    [dados]
  );

  function createObj({ key = "codigo", data = [], prefix = "" }) {
    if (Array.isArray(data)) {
      return data.reduce((acc, cur) => {
        acc[`${prefix}${cur[key]}`] = cur;
        return acc;
      }, {});
    }
    return {};
  }

  useEffect(() => {
    if (fila && optionsPesquisa?.length > 0) {
      setSelectPesquisa(fila);
    }
  }, [optionsPesquisa, fila]);

  function onChangePesquisa(e) {
    pesquisaSelect.upDateValue(e.value);
    pesquisaSelect.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("pesquisaId", e.value);

    if (salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    onFilterChange((prev) => ({
        ...prev,
        title: e.value,
    }));

    setTimeout(() => formikRef?.current?.setFieldTouched("pesquisaId", true));
    setPesquisa(e.value);
  }

  useEffect(() => {
    if (salvarLocalStorage) {
      const pesquisaSalva = localStorage.getItem(chave);

      if (pesquisaSalva) {
        const pesquisaObj = JSON.parse(pesquisaSalva);
        setPesquisa(pesquisaObj.value);
        onChangePesquisa(pesquisaObj);
        setFila(pesquisaObj.value);
      }
    }
  }, []);

  function setSelectPesquisa(id) {
    if (optionsPesquisa?.length > 0) {
      const pesquisa = optionsPesquisa.find((p) => p.value === id);
      if (pesquisa) onChangePesquisa(pesquisa);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  return {
    optionsPesquisa,
    dados,
    fila,
    onChangePesquisa,
    setSelectPesquisa,
    pesquisa,
    pesquisaSelect,
    pesquisasObjId,
    pesquisasObjCodigo,
    pesquisasObjNome,
  };
};

export default usePesquisa;
